import React from "react";

const holder = {
  closeDropdownSelector(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.internalStateSetter({ isOpen: false, searchTerm: '' });
      document.removeEventListener("mousedown", holder.closeDropdownSelector)
    }
  }
};

export default {
  'Dropdown.Selector': async ({ isOpen, containerRef, inputRef, disabled }, _, internalStateSetter) => {
    if (disabled) return;
    let newInputRef = inputRef;
    let newContainerRef = containerRef;

    if (!inputRef || !containerRef) {
      newInputRef = React.createRef();
      newContainerRef = React.createRef();
      await internalStateSetter({ inputRef: newInputRef, containerRef: newContainerRef });
    }

    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = newContainerRef;

    await internalStateSetter({ isOpen: !isOpen, searchTerm: '' });
    if (isOpen) {
      document.removeEventListener("mousedown", holder.closeDropdownSelector);
    } else {
      inputRef?.current?.children?.[inputRef?.current?.children.length - 1]?.focus();
      inputRef?.current?.children?.[inputRef?.current?.children.length - 1]?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
      document.addEventListener("mousedown", holder.closeDropdownSelector);
    }
  },
  'Dropdown.Selector.LeftSide.Wrapper.SearchInput': ({ value, disabled }, _, internalStateSetter) => {
    if (disabled) return;
    internalStateSetter({ searchTerm: value, isOpen: true })
  },
  'Dropdown.Selector.LeftSide.Wrapper.SearchInput(Keydown)': () => {
  },
  'Dropdown.Selector.LeftSide.Wrapper.SelectedButton': ({ selectedOptionId, selectedOptionIds }, outlet) => {
    outlet({ selectedOptionIds: selectedOptionIds.filter(id => id !== selectedOptionId) })
  },
  'Dropdown.Body.Option': ({ option, selectedOptionIds, multipleSelect, inputRef }, outlet, internalStateSetter) => {
    if (multipleSelect) {
      if (selectedOptionIds.includes(option.id)) {
        outlet({ selectedOptionIds: selectedOptionIds.filter(id => id !== option.id) })
      } else {
        outlet({ selectedOptionIds: [...selectedOptionIds, option.id] })
      }
      inputRef?.current?.children?.[selectedOptionIds.length]?.focus();
      inputRef?.current?.children?.[selectedOptionIds.length]?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    } else {
      outlet({ selectedOptionIds: option.id === selectedOptionIds[0] ? [] : [option.id] })
      internalStateSetter('isOpen', false);
    }
    internalStateSetter({ searchTerm: '' })
  },
  'Dropdown.Body.ClearAllHeader': ({ options, count, showAll }, outlet, internalStateSetter) => {
    if (count === 0 || showAll) {
      outlet({ selectedOptionIds: options.map(o => o.id) })
    } else {
      outlet({ selectedOptionIds: [] })
    }
    internalStateSetter({ searchTerm: '', isOpen: false })
  }
}